<script setup lang="ts">
import Product from "~/models/Product";
import SafeHtml from "~/components/utils/SafeHtml.vue";

defineProps({
  product: {
    type: Product,
    required: true,
  },
});
</script>

<template>
  <aside>
    <!-- Characteristics -->
    <div
      v-for="(item, index) in product.characteristics"
      :key="index"
      class="card mb-3"
    >
      <div class="row g-0">
        <div class="col-md-4 d-flex align-items-center ps-2 py-2">
          <img
            v-if="item.icon"
            class="img-fluid rounded-start bd-placeholder-img mx-auto characteristic-icon"
            :src="item.icon"
            :alt="item.name || ''"
          />
        </div>
        <div class="col-md-8">
          <div class="card-body">
            <h5 class="card-title fw-semibold">{{ item.name }}</h5>
            <p class="card-text">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Bullet Points -->
    <div v-if="product.bullet_points.length > 0" class="card mb-3">
      <ul class="list-group list-group-flush">
        <li
          v-for="(item, index) in product.bullet_points"
          :key="index"
          class="list-group-item d-flex justify-content-between align-items-center gap-3"
        >
          <safe-html class="fw-semibold text-truncate" :html="item" />
          <i class="bi bi-check-circle text-success fs-5" />
        </li>
      </ul>
    </div>
    <!-- Product External Links -->
    <div
      v-if="
        product.manufacturer_link || product.specs_file || product.manual_file
      "
      class="card mb-3"
    >
      <ul class="list-group list-group-flush">
        <li
          v-if="product.manufacturer_link"
          class="list-group-item list-group-item-action list-group-item-primary"
        >
          <a
            v-if="product.manufacturer_link"
            :href="product.manufacturer_link"
            rel="nofollow"
            class="d-flex justify-content-between align-items-center gap-3 link-underline link-underline-opacity-0"
            target="_blank"
          >
            Ir a la página del fabricante
            <i class="bi bi-link fs-5" />
          </a>
        </li>
        <li
          v-if="product.specs_file"
          class="list-group-item list-group-item-action list-group-item-info"
        >
          <a
            v-if="product.specs_file"
            :href="product.specs_file"
            rel="nofollow"
            class="d-flex justify-content-between align-items-center gap-3 link-underline link-underline-opacity-0"
            target="_blank"
          >
            Ir al manual de configuración
            <i class="bi bi-link fs-5" />
          </a>
        </li>
        <li
          v-if="product.manual_file"
          class="list-group-item list-group-item-action list-group-item-secondary"
        >
          <a
            :href="product.manual_file"
            rel="nofollow"
            class="d-flex justify-content-between align-items-center gap-3 link-underline link-underline-opacity-0"
            target="_blank"
          >
            Ir al manual de uso
            <i class="bi bi-link fs-5" />
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.characteristic-icon {
  max-width: 120px;
  max-height: 60px;
}
</style>
